import styled from 'styled-components'

import { colors } from '../../styles/colors'

interface IContainerPageProps {
  $active?: boolean
}

export const Container = styled.div`
  width: 100%;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;

  background: ${colors.white};

  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.25);
`

export const ContainerPage = styled.div<IContainerPageProps>`
  width: 20px;
  height: 20px;
  border-radius: 10px;

  background: ${props => (props.$active ? colors.green : colors.blue)};

  margin: 0px 8px;

  display: flex;
  align-items: center;
  justify-content: center;

  color: ${colors.white};

  font-family: Roboto, sans-serif;
  font-weight: 700;
  font-size: 14px;

  cursor: pointer;
`
